import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import { decorateIntlMessages } from '../../common/rosetta_formatted_message';
import classNames from 'classnames';
import MediaQuery from '../../common/media_query';
import ResponsiveImg from '../../common/responsive_img';
import { sendAnalyticsEvent } from '../../../utils/analytics';
import sanitizeText from '../../../utils/sanitize_text';

const NowPlayingMessage = (
  <RosettaFormattedMessage parentFilename={__filename}
    id="now_playing"
    description="Message that displays on a thumbnail for a playing video"
    defaultMessage="Now Playing"
  />
);

const FORMATTED_MESSAGES = decorateIntlMessages(__filename, defineMessages({
  'episode_alt_text': {
    id: 'episode_alt_text',
    description: 'Message for alt text on the video thumbnail',
    defaultMessage: 'Video Thumbnail'
  }
}));

export const IMG_WIDTH_DESKTOP = 205;
export const IMG_HEIGHT_DESKTOP = IMG_WIDTH_DESKTOP * 170 / 302;
export const IMG_WIDTH_MOBILE = 150;
export const IMG_HEIGHT_MOBILE = IMG_WIDTH_MOBILE * 170 / 302;

export class Episode extends Component {
  handleClick = () => sendAnalyticsEvent(
    'Recommended Shows',
    'Click',
    sanitizeText(this.props.title),
    this.props.idx
  );

  render() {
    const { formatMessage } = this.props.intl;

    const altText = formatMessage(FORMATTED_MESSAGES.episode_alt_text);

    return (
      <Link to={this.props.path} onClick={this.handleClick}>
        <div className={classNames('episode', { 'active': this.props.isActive })}>
          <figure>
            <MediaQuery breakpoint="desktop">
              <ResponsiveImg src={this.props.opener_image_302x170}
                width={IMG_WIDTH_DESKTOP}
                height={IMG_HEIGHT_DESKTOP}
                alt={altText}
              />
            </MediaQuery>
            <MediaQuery breakpoint="notDesktop">
              <ResponsiveImg src={this.props.opener_image_302x170}
                width={IMG_WIDTH_MOBILE}
                height={IMG_HEIGHT_MOBILE}
                alt={altText}
              />
            </MediaQuery>
            {this.props.isActive && NowPlayingMessage}
          </figure>
          <span className="title"
            dangerouslySetInnerHTML={{ __html: this.props.title }}
          />
        </div>
      </Link>
    );
  }
}

Episode.propTypes = {
  isActive: PropTypes.bool.isRequired,
  opener_image_302x170: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  idx: PropTypes.number.isRequired,
  intl: PropTypes.object.isRequired
};

export default injectIntl(Episode);
